import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import Star from '../components/Star';
import ParameterErrors from '../errors/ParameterErrors';
import IconButtonNonReact from '../components/IconButtonNonReact';
import PlotStatus from '../site/PlotStatus';
import AssetsManager from '../assets_management/AssetsManager';
import Urls from '../urls/Urls';
import UrlHelper from '../core/UrlHelper';
import ResizeWatcher from '../ui_core/ResizeWatcher';
import VideoPlayer from '../components/VideoPlayer';
import Once from '../core/Once';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import FullScreen from '../ui_core/FullScreen';
import PlotDetailedInformationSectionType from './PlotDetailedInformationSectionType';
import eventEnable from '../core/eventEnable';
const {throwNotProvided}=ParameterErrors;
export default class PlotDetailedInformationVideo {
	constructor(props){
		const { siteJsonUnitPlot, showImagesFullScreen, configuration}=props;
		eventEnable(this);
		this._configuration = configuration;
		this._siteJsonUnitPlot = siteJsonUnitPlot;
		this._element = document.createElement('div');
		this._element.classList.add('video');
		this._dispatchLoaded = this._dispatchLoaded.bind(this);
		this._videoUrlChanged = this._videoUrlChanged.bind(this);
		this._videoPlayer = new VideoPlayer({
			maximized:false,
			forceFillWidth:true,
			toggleMaximizeButton:true
		});
		this._element.appendChild(this._videoPlayer.element);
		this._setupFromSiteJsonUnitPlot();
	}
	set plot(siteJsonUnitPlot){
		this._siteJsonUnitPlot = siteJsonUnitPlot;
		this._setupFromSiteJsonUnitPlot();
	}
	_setupFromSiteJsonUnitPlot(){
		this._propertyBindingTourUrl?.dispose();
		this._propertyBindingTourUrl = PropertyBindingFactory.standard(this, this._siteJsonUnitPlot.houseType, 'videoUrl', this._videoUrlChanged);
	}
	_videoUrlChanged(value){
		const noUrl =  value===undefined||value===null||value==='';
		const url =noUrl?null:
		(value.indexOf('http')>=0?value:(Urls.getAssetsForSite(this._configuration.siteSlug)+value));
		console.log('URL WAS ');
		console.log(url);
		this._videoPlayer.load({url:url});
	}
	get element(){
		return this._element;
	}
	get sectionType(){
		return PlotDetailedInformationSectionType.Video;
	}
	_dispatchLoaded(){
		this.dispatchEvent({type:'loaded'});
	}
}